// Gainforce contract revert codes -> readable messages
const ERROR_CODES = {
  E1: 'This wallet is already registered',
  E2: 'Invalid package amount (or user ID already in use)',
  E3: 'Sponsor is not active',
  E4: 'Account not registered, blacklisted or invalid package',
  E5: 'Account is blacklisted',
  E6: 'Amount must be at least your current package',
  E7: 'Account not registered or blacklisted',
  E8: 'Amount is below the minimum or above your available balance',
  E9: 'Invalid destination or amount exceeds pool balance',
  E12: 'Owner / admin cannot be blacklisted',
  E13: 'Zero address is not allowed',
  E14: 'No placement found',
  E15: 'Could not generate a user ID, please try again',
  E16: 'Placement user is not active',
  E17: 'That placement slot is already taken',
  E18: 'Placement must be inside the sponsor\'s team',
  E20: 'User ID is already in use',
  E22: 'Time unit must be greater than 0',
  E23: 'Binary depth must be 1 - 500 and generation depth 1 - 50',
  X1: 'Only the owner can do this',
  X2: 'Only the admin or owner can do this',
  // Storage.logicContract is not set to the current Logic
  X4: 'Platform contracts are not connected yet. Please try again later.'
};

export const parseContractError = (err, fallback = 'Transaction failed') => {
  if (err?.code === 4001 || err?.code === 'ACTION_REJECTED') return 'Transaction rejected';

  const raw = [
    err?.reason,
    err?.error?.message,
    err?.data?.message,
    err?.error?.data?.message,
    err?.message
  ].filter(Boolean).join(' ');

  const match = raw.match(/\b([EX]\d{1,2})\b/);
  if (match && ERROR_CODES[match[1]]) return ERROR_CODES[match[1]];
  if (/Max 50%/.test(raw)) return 'Percentage cannot exceed 50%';
  if (/exceeds allowance/i.test(raw)) return 'Token approval too low - approve again';
  if (/exceeds balance/i.test(raw)) return 'Insufficient USDT balance';
  if (/insufficient funds/i.test(raw)) return 'Not enough BNB for gas';

  return err?.reason || fallback;
};
